import { render, staticRenderFns } from "./tinkSensor.vue?vue&type=template&id=4dd72fc0"
import script from "./tinkSensor.vue?vue&type=script&lang=js"
export * from "./tinkSensor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports